import "./Livehighlight.css";
import newpage from "./../livescoreImage/newpage.jpg";
import bray from "./../livescoreImage/bray.png";
import worldCup from "../../home/HomeImage/worldcup.png";
import { useState, useRef, useEffect } from "react";
import { NavLink, useLocation, useParams, useNavigate } from "react-router-dom";
import Livestat from "../livestats/Livestats";
import Livelineup from "../livelineUp/Livelineup";
import Livesummary from "../livesummary/Livesummary";
import Livecommentary from "../livecommentary/Livecommentary";
import Livecomment from "../livecomment/Livecomment";
import Skeleton from "../../../components/Skeleton";
import { Helmet } from "react-helmet-async";
import ReactPlayer from "react-player";

const Livehighlight = ({ handleBack, dark, MyBaseUrl }) => {
  const location = useLocation();
  const { slug, id, tab } = useParams();

  const navigate = useNavigate();

  const matchIdFromState = location?.state?.matchId;
  const matchId = matchIdFromState || Number(id);

  const [matchDetails, setMatchDetails] = useState(null);
  const [loading, setLoading] = useState(true);

  const [selected, setSelected] = useState(null);
  const [active, setActive] = useState(1);

  useEffect(() => {
    const fetchMatch = async () => {
      if (!matchId) return;

      setLoading(true);

      try {
        const res = await fetch(`${MyBaseUrl}/matches/${matchId}`);
        const json = await res.json();
        const data = json?.data || null;

        setMatchDetails(data);
      } catch (err) {
        console.log("match details error", err);
      } finally {
        setLoading(false);
      }
    };

    fetchMatch();
  }, [matchId]);

  useEffect(() => {
    if (loading || !matchDetails || tab) return;

    const statusShort = matchDetails?.fixture?.status?.short;

    if (statusShort === "NS") {
      setSelected("lineup");
      setActive(2);

      navigate(`/matches/${slug}/${id}/lineup`, {
        replace: true,
      });
    } else {
      setSelected("stat");
      setActive(1);

      navigate(`/matches/${slug}/${id}/stat`, {
        replace: true,
      });
    }
  }, [loading, matchDetails, tab, slug, id, navigate]);

  useEffect(() => {
    if (!tab) return;

    const tabMap = {
      stat: 1,
      lineup: 2,
      summary: 3,
      commentary: 4,
      comment: 5,
    };

    if (!tabMap[tab]) {
      navigate(`/matches/${slug}/${id}/stat`, {
        replace: true,
      });
      return;
    }

    setSelected(tab);
    setActive(tabMap[tab] || 1);
  }, [tab]);
  const home = matchDetails?.teams?.home;
  const away = matchDetails?.teams?.away;
  const goals = matchDetails?.goals;
  const score = matchDetails?.score || {};
  const events = matchDetails?.events || [];
  const statistics = matchDetails?.statistics || [];
  const lineups = matchDetails?.lineups || [];
  const players = matchDetails?.players || [];

  const createSlug = (name = "") =>
    name
      ?.toLowerCase()
      .trim()
      .replace(/[^a-z0-9\s-]/g, "")
      .replace(/\s+/g, "");

  const homeSlug = createSlug(home?.name);
  const awaySlug = createSlug(away?.name);

  const homeTeamUrl = `${homeSlug}-${home?.id}`;
  const awayTeamUrl = `${awaySlug}-${away?.id}`;

  const goalEvents = events?.filter((e) => e?.type === "Goal") || [];

  const homeScorers = goalEvents.filter((g) => g?.team?.id === home?.id);

  const awayScorers = goalEvents.filter((g) => g?.team?.id === away?.id);

  // const onSelect = (id) => setSelected(id);

  const handleTabChange = (tab, activeIndex) => {
    setSelected(tab);
    setActive(activeIndex);

    navigate(`/matches/${slug}/${id}/${tab}`);
  };
  const renderNav = () => {
    switch (selected) {
      case "stat":
        return (
          <Livestat dark={dark} match={matchDetails} statistics={statistics} />
        );
      case "lineup":
        return (
          <Livelineup
            dark={dark}
            match={matchDetails}
            lineups={lineups}
            players={players}
            events={events}
            myhome={home}
            myaway={away}
            HomeTeam={homeTeamUrl}
            AwayTeam={awayTeamUrl}
          />
        );
      case "summary":
        return (
          <Livesummary
            events={events}
            homeTeam={home}
            awayTeam={away}
            status={matchDetails?.fixture?.status}
            goals={goals}
            score={score}
            matchDetails={matchDetails}
            dark={dark}
          />
        );
      case "commentary":
        return (
          <Livecommentary
            dark={dark}
            events={events}
            homeTeam={home}
            awayTeam={away}
            goals={goals}
            score={score}
            status={matchDetails?.fixture?.status}
          />
        );
      case "comment":
        return <Livecomment dark={dark} match={matchDetails} events={events} />;
      default:
        return (
          <Livestat dark={dark} match={matchDetails} statistics={statistics} />
        );
    }
  };

  //   useEffect(() => {
  //   if (!tab) return;

  //   const tabMap = {
  //     stat: 1,
  //     lineup: 2,
  //     summary: 3,
  //     commentary: 4,
  //     comment: 5,
  //   };

  //   setSelected(tab);
  //   setActive(tabMap[tab] || 1);
  // }, [tab]);

  if (!selected) {
    return <Skeleton dark={dark} count={3} />;
  }
  if (loading) {
    return (
      <div
        className="highlightWrapper"
        style={dark ? { backgroundColor: "#111111e7", color: "#fff" } : {}}>
        <Skeleton dark={dark} count={6} />
      </div>
    );
  }

  const status = matchDetails?.fixture?.status;

  const extraTime =
    score?.extratime?.home !== null || score?.extratime?.away !== null;
  const penalty =
    score?.penalty?.home !== null || score?.penalty?.away !== null;

  return (
    <div className="homer">
      <Helmet>
        <title>
          {matchDetails?.teams?.home?.name || "Team A"} vs{" "}
          {matchDetails?.teams?.away?.name || "Team B"} Live Match | Goal Arena
        </title>

        <meta
          name="description"
          content={`Live match updates for ${matchDetails?.teams?.home?.name || "Team A"} vs ${matchDetails?.teams?.away?.name || "Team B"}. Get real-time scores, stats, lineups, commentary, and match highlights.`}
        />

        <meta
          name="keywords"
          content="live football match, live score, match highlights, football stats, lineups, commentary, soccer live updates"
        />

        <meta property="og:title" content="Live Match | Goal Arena" />

        <meta
          property="og:description"
          content="Follow live football match updates, stats, and highlights in real time."
        />

        <meta property="og:type" content="website" />

        <meta name="twitter:card" content="summary_large_image" />

        {matchDetails?.league?.name && (
          <meta name="article:section" content={matchDetails.league.name} />
        )}
      </Helmet>
      <div className="highlightWrapper">
        <section className="firstsection">
          <NavLink
            className="navy"
            to={`/competition/${
              matchDetails?.league?.name
                ? matchDetails?.league?.name.replace(/\s+/g, "-").toLowerCase()
                : "league"
            }/${matchDetails?.league?.id}`}
            style={{
              textDecoration: "none",
              display: "flex",
              flexDirection: "row",
              width: "100%",
              justifyContent: "space-between",
              alignItems: "center",
            }}>
            <div className="lll">
              <img
                src={
                  matchDetails?.league?.id === 1
                    ? worldCup
                    : matchDetails?.league?.logo
                }
                alt=""
              />
              <nav>
                <h1
                  className="h1"
                  style={dark ? { color: "#fafafaff" } : { color: "#161819" }}>
                  {matchDetails?.league?.name}
                </h1>
                <p
                  className="h1"
                  style={dark ? { color: "#fafafaff" } : { color: "#161819" }}>
                  {matchDetails?.league?.country}
                </p>
              </nav>
            </div>
          </NavLink>

          <div
            className="matchHighlightVideo"
            style={
              dark
                ? {
                    background: "#1b1b1b",
                    border: "1px solid #2f2f2f",
                  }
                : {
                    background: "#ffffff",
                    border: "1px solid #ececec",
                  }
            }>
            <div className="videoWrapper">
              <ReactPlayer
                src="https://www.youtube.com/watch?v=63P006ZKx20"
                controls
                width="100%"
                height="100%"
                style={{ objectFit: "cover" }}
                playing={false}
              />

              {/* <div className="videoOverlay">
                <h3>
                  {home?.name} vs {away?.name} Highlights
                </h3>

                <p>
                  Watch the best moments, goals, chances and match action.
                </p>
              </div> */}
            </div>
          </div>

          <div
            id="lighthead"
            style={
              dark
                ? { backgroundColor: "#333333ff" }
                : { backgroundColor: "white" }
            }>
            <div
              className="highlightscore"
              style={{ backgroundColor: "transparent" }}>
              <NavLink to={`/teams/${homeTeamUrl}`}>
                <nav className="homie">
                  <img src={home?.logo || bray} alt="" />
                  <h2
                    style={
                      dark ? { color: "#fafafaff" } : { color: "#161819" }
                    }>
                    {home?.name}
                  </h2>
                </nav>
              </NavLink>

              <nav
                className="dayy"
                style={
                  dark
                    ? {
                        color: "#fafafaff",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                      }
                    : {
                        color: "#161819",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                      }
                }>
                <nav
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}>
                  {status?.short === "NS" ? (
                    <>
                      <h1
                        style={
                          dark ? { color: "#fafafaff" } : { color: "#161819" }
                        }>
                        {new Date(
                          matchDetails?.fixture?.date,
                        ).toLocaleTimeString([], {
                          hour: "2-digit",
                          minute: "2-digit",
                          hour12: false,
                        })}
                      </h1>
                      <strong
                        style={
                          dark
                            ? { color: "#c9c6c6ff", marginTop: "-10px" }
                            : { color: "#3e3f3f", marginTop: "-10px" }
                        }>
                        {new Date(
                          matchDetails?.fixture?.date,
                        ).toLocaleDateString(undefined, {
                          day: "2-digit",
                          month: "long",
                        })}
                      </strong>
                      <strong
                        style={
                          dark
                            ? { color: "#c9c6c6ff", marginTop: "-10px" }
                            : { color: "#3e3f3f", marginTop: "-10px" }
                        }>
                        {matchDetails?.fixture?.venue?.name ||
                          "Unknown stadium"}
                      </strong>
                    </>
                  ) : (
                    <>
                      {status?.short === "CANC" ? (
                        <h1
                          style={
                            dark ? { color: "#fafafaff" } : { color: "#161819" }
                          }>
                          {status?.short}
                        </h1>
                      ) : (
                        <h1
                          style={
                            dark ? { color: "#fafafaff" } : { color: "#161819" }
                          }>
                          {goals?.home ?? 0} : {goals?.away ?? 0}
                        </h1>
                      )}
                      <strong
                        style={
                          dark
                            ? { color: "#c9c6c6ff", marginTop: "0px" }
                            : { color: "#3e3f3f", marginTop: "0px" }
                        }>
                        {new Date(
                          matchDetails?.fixture?.date,
                        ).toLocaleDateString(undefined, {
                          day: "2-digit",
                          month: "long",
                        })}
                      </strong>
                      <strong
                        style={
                          dark
                            ? { color: "#c9c6c6ff", marginTop: "-8px" }
                            : { color: "#3e3f3f", marginTop: "-8px" }
                        }>
                        {status?.elapsed < 90
                          ? `${status?.elapsed}'`
                          : penalty
                            ? ` PEN: ${score?.penalty?.home ?? 0} - ${score?.penalty?.away ?? 0}`
                            : extraTime &&
                              ` (ET: ${score?.extratime?.home ?? 0} - ${score?.extratime?.away ?? 0})`}
                      </strong>
                    </>
                  )}
                </nav>
              </nav>

              <NavLink to={`/teams/${awayTeamUrl}`}>
                <nav className="awaie">
                  <img src={away?.logo || bray} alt="" />
                  <h2
                    style={
                      dark ? { color: "#fafafaff" } : { color: "#161819" }
                    }>
                    {away?.name}
                  </h2>
                </nav>
              </NavLink>
            </div>

            {goalEvents.length > 0 && (
              <div
                className="goalSummary"
                style={
                  dark
                    ? { borderTop: "0.3px solid #5252529f" }
                    : { borderTop: "0.3px solid #eee" }
                }>
                <div className="goalColumn left">
                  {homeScorers.map((g, i) => {
                    const player = g?.player;

                    return (
                      <NavLink
                        to={`/players/${player?.name
                          ?.trim()
                          .replace(/[^a-zA-Z.\s]/g, "")
                          .replace(/\s+/g, "-")
                          .toLowerCase()}-${player?.id}`}
                        state={{ player, leagueSlug: slug }}
                        key={player?.id || i}
                        style={{ textDecoration: "none", color: "inherit" }}>
                        <p
                          style={
                            dark ? { color: "#e4e4e4ff" } : { color: "#161819" }
                          }>
                          {g?.player?.name} {g?.time?.elapsed}'
                        </p>
                      </NavLink>
                    );
                  })}
                </div>

                <div className="goalColumn right">
                  {awayScorers.map((g, i) => {
                    const player = g?.player;

                    return (
                      <NavLink
                        to={`/players/${player?.name
                          ?.trim()
                          .replace(/[^a-zA-Z.\s]/g, "")
                          .replace(/\s+/g, "-")
                          .toLowerCase()}-${player?.id}`}
                        state={{ player, leagueSlug: slug }}
                        key={player?.id || i}
                        style={{ textDecoration: "none", color: "inherit" }}>
                        <p style={dark ? {} : { color: "#161819" }}>
                          {g?.player?.name} {g?.time?.elapsed}'
                        </p>
                      </NavLink>
                    );
                  })}
                </div>

                <div
                  className="goalFooter"
                  style={dark ? { color: "whitesmoke" } : { color: "#3e3f3f" }}>
                  (HT {score?.halftime?.home ?? 0}-{score?.halftime?.away ?? 0})
                  {"  "}
                  {status?.elapsed >= 90 && (
                    <span>
                      (FT {score?.fulltime?.home ?? 0}-
                      {score?.fulltime?.away ?? 0})
                    </span>
                  )}
                </div>
              </div>
            )}
          </div>

          <div className="higlightcontent">
            <nav>
              <ul>
                {status?.short !== "NS" && (
                  <li
                    style={
                      dark
                        ? { color: active === 1 ? "whitesmoke" : "#979797ff" }
                        : { color: active === 1 ? "whitesmoke" : "#3e3f3f" }
                    }
                    className={active === 1 ? "active" : "navlink"}
                    onClick={() => handleTabChange("stat", 1)}
                    id="stat">
                    Stats
                  </li>
                )}

                <li
                  style={
                    dark
                      ? { color: active === 2 ? "whitesmoke" : "#979797ff" }
                      : { color: active === 2 ? "whitesmoke" : "#3e3f3f" }
                  }
                  className={active === 2 ? "active" : "navlink"}
                  onClick={() => handleTabChange("lineup", 2)}
                  id="lineup">
                  Line-Up
                </li>

                {status?.short !== "NS" && (
                  <li
                    style={
                      dark
                        ? { color: active === 3 ? "whitesmoke" : "#979797ff" }
                        : { color: active === 3 ? "whitesmoke" : "#3e3f3f" }
                    }
                    className={active === 3 ? "active" : "navlink"}
                    onClick={() => handleTabChange("summary", 3)}
                    id="summary">
                    Summary
                  </li>
                )}

                {status?.short !== "NS" && (
                  <li
                    style={
                      dark
                        ? { color: active === 4 ? "whitesmoke" : "#979797ff" }
                        : { color: active === 4 ? "whitesmoke" : "#3e3f3f" }
                    }
                    className={active === 4 ? "active" : "navlink"}
                    onClick={() => handleTabChange("commentary", 4)}
                    id="commentary">
                    Commentary
                  </li>
                )}

                {/* <li
                style={dark ? { color: active === 5 ? "whitesmoke" : "#979797ff" } : { color: active === 5 ? "whitesmoke" : "#3e3f3f" }}
                className={active === 5 ? "active" : "navlink"}
                onClick={navClickkkkk}
                id="comment"
              >
                Comment
              </li> */}
              </ul>
            </nav>

            {renderNav()}
          </div>
        </section>
      </div>
    </div>
  );
};

export default Livehighlight;
